import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UserBar from './UserBar.vue';
import config from '@/config';
import { USER_AUTH_URL } from "@/store/mutation-types";
export default {
  components: {
    UserBar
  },
  setup() {
    const positionPath = computed(() => {
      const oriArr = ['online', 'offline', 'putlist'];
      const nowArr = [];
      let userAuth = sessionStorage.getItem(USER_AUTH_URL);
      var urlPermsArr = JSON.parse(userAuth ? userAuth : '[]');
      oriArr.forEach(o => {
        if (urlPermsArr.includes(o)) {
          nowArr.push('/operation/' + o);
        }
      });
      return nowArr.length > 0 ? nowArr[0] : '';
    });
    const handleSelect = (key, keyPath) => {
      // console.log(key)
    };
    const fullScreenHandler = () => {
      var _window$ipcRenderer;
      return (_window$ipcRenderer = window.ipcRenderer) === null || _window$ipcRenderer === void 0 ? void 0 : _window$ipcRenderer.send('full-screen');
    };
    const reload = () => window.location.reload();
    const route = useRoute();
    const routers = useRouter().options.routes;
    const headerMenus = routers.find(i => i.name === 'main').children;
    const defaultActive = computed(() => {
      return '/' + route.path.split('/')[1];
    });
    const hideHeader = computed(() => {
      return route.query.hideHeader || route.meta.hideHeader || config.hideHeader;
    });
    const hideAside = computed(() => {
      return 'hideAside' in route.meta ? route.meta.hideAside : false;
    });
    const blueBg = computed(() => {
      return 'blueBg' in route.meta ? route.meta.blueBg : false;
    });
    // nextTick(() => {
    //   const asideDom = document.querySelector('.el-aside')
    //   if (hideAside.value) asideDom.style.display = 'none'
    // })
    return {
      positionPath,
      hideHeader,
      hideAside,
      blueBg,
      headerMenus,
      defaultActive,
      handleSelect,
      reload,
      fullScreenHandler
    };
  }
};